import memoizeOne from 'memoize-one';
import { createIntl, createIntlCache, type IntlShape, type IntlConfig } from 'react-intl';

let cache;
/** We want to be able to update the instance of intl from elsewhere and still retain the ability to import it from here. */
// eslint-disable-next-line import/no-mutable-exports
let intl: IntlShape;

/**
 * Generate Intl object
 */
const generateIntl = memoizeOne(
  (locale: IntlConfig['locale'] = 'en', messages: IntlConfig['messages']): IntlShape => {
    cache = createIntlCache();

    intl = createIntl({ locale, messages }, cache);
    return intl;
  }
);

export { generateIntl, intl };
